/**
 * Cypher fragment that resolves a `:UDTDefinition` from an
 * Ignition-style type identifier (`<folder>/<leaf>`, or `<leaf>` at
 * the root of `_types_`). Tolerates two historical id schemes so
 * the browser keeps working with backups ingested before
 * `mapUdtDefinitions` was patched to namespace folder-resident UDTs
 * by their full path.
 *
 * Not a standalone query — interpolated into the larger
 * `getPlantProviderFolderNode` / `getPlantUdtFolderNode` queries
 * via template-string substitution so the matching definition
 * binds to a caller-chosen alias inside their own MATCH chain.
 *
 * @param defAlias    Cypher alias to bind the matched definition
 *                    (e.g. `'def'`, `'d0'`).
 * @param typeIdExpr  Cypher expression that evaluates to the type
 *                    id we're resolving (e.g. `'ui.type_id'`,
 *                    `'m0.udt_type_id'`).
 */
export function matchUdtDefByTypeId(defAlias: string, typeIdExpr: string): string {
  return `OPTIONAL MATCH (${defAlias}:UDTDefinition)
                WHERE (
                    ${defAlias}.name = ${typeIdExpr}
                    OR (
                      coalesce(${defAlias}.folder_name, '') <> ''
                      AND ${defAlias}.folder_name + '/' + ${defAlias}.name = ${typeIdExpr}
                    )
                  )`
}
